import {autoImplement} from '@/util';


export interface ApiSubsidiary {
  NiederlassungNr: number;
  Bezeichnung: string;
  Name1: string;
  // incompl
}

export interface SubsidiaryFilters {}

export default class Subsidiary extends autoImplement<ApiSubsidiary>() {
  static fromApi(apiSubsidiary: ApiSubsidiary): Subsidiary {
    return new Subsidiary(apiSubsidiary);
  }
}
